<template>
  <v-layout>
    <v-dialog v-model="dialog_ativo" persistent max-width="700px">
      <v-card>
        <v-card-title class="pl-2">
          <v-btn color="#000" class="mr-3" icon @click="() => fechar()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <span class="headline">Exportação Protheus</span>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-3">
          <v-container class="pb-0">
            <v-select
              v-model="selects.filiais.value"
              :items="selects.filiais.items"
              chips
              label="Selecione uma Filial*"
              height="10"
              outlined
              item-value="id"
              item-text="descricao"
              :error-messages="filialErrors"
              :disabled="disabledTextField"
              @input="$v.selects.filiais.value.$touch()"
              @blur="$v.selects.filiais.value.$touch()"
              :loading="loading.filial"
            ></v-select>

            <v-select
              v-model="selects.fornecedores.value"
              :items="selects.fornecedores.items"
              chips
              label="Selecione o Fornecedor / Loja*"
              height="10"
              outlined
              item-value="cnpj"
              item-text="razao_social"
              :error-messages="fornecedorErrors"
              :disabled="disabledTextField"
              @input="$v.selects.fornecedores.value.$touch()"
              @blur="$v.selects.fornecedores.value.$touch()"
              :loading="loading.fornecedor"
            ></v-select>

            <v-select
              v-model="selects.condPagamento.value"
              :items="selects.condPagamento.items"
              chips
              label="Selecione a Condição Pagmento*"
              height="10"
              outlined
              item-value="id"
              item-text="descricao"
              :error-messages="condPagamentoErrors"
              :disabled="disabledTextField"
              @input="$v.selects.condPagamento.value.$touch()"
              @blur="$v.selects.condPagamento.value.$touch()"
              :loading="loading.condPagamento"
            ></v-select>

            <div class="d-flex align-center">
              <div class="w-50-porcento pr-2">
                <v-text-field
                  v-model="dataEntrega"
                  label="Data Entrega"
                  outlined
                  readonly
                  type="date"
                  placeholder="Placeholder"
                  :messages="`${qtdeDias} dias`"
                  :error-messages="dataEntregaErrors"
                  :disabled="disabledTextField"
                  @input="$v.dataEntrega.$touch()"
                  @blur="$v.dataEntrega.$touch()"
                  @focus="ev => ev.target.blur()"
                  :loading="loading.condPagamento"
                />
              </div>

              <div class="w-50-porcento pl-2">
                <v-text-field
                  v-model="data_limite_faturamento"
                  label="Data limite faturamento"
                  outlined
                  type="date"
                  placeholder="Placeholder"
                  :messages="`${qtdeDiasDataLimiteFaturamento} dias`"
                  :error-messages="dataLimiteFaturamentoErrors"
                  :disabled="disabledTextField"
                  @input="$v.data_limite_faturamento.$touch()"
                  @blur="$v.data_limite_faturamento.$touch()"
                  :loading="loading.condPagamento"
                />
              </div>
            </div>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="() => fechar()">Fechar</v-btn>
          <v-btn
            v-if="!disabledTextField"
            text
            @click="exportarProtheus()"
            :disabled="produtoInvalidoParaExportacao||(codProtheus ? false : true)"
          >
            Exportar Pedido
          </v-btn>
          <v-btn v-else text @click="exportarProtheus()">Editar pedido</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogStatus" persistent max-width="600px">
      <v-card>
        <v-card-title class="pl-2">
          <v-btn
            v-if="erros.length > 0"
            color="#000"
            class="mr-3"
            icon
            @click="() => voltar()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-btn v-else color="#000" class="mr-3" icon @click="fechar()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <span v-if="erros.length > 0" class="headline">Erro na Exportação</span>
          <span v-else-if="produtoInvalidoParaExportacao" class="headline">Exportação Inválida</span>
          <span v-else class="headline">Pedido Exportado</span>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
          <div v-if="erros.length > 0" class="mt-5">
            <h3
              v-for="(erro, i) in erros"
              :key="i"
              class="text-center mb-5"
              style="color: red; text-align: left !important"
            >
              {{ i + 1 }} - {{ erro.Message }}
            </h3>
          </div>
          <div v-else-if="produtoInvalidoParaExportacao">
            <h3 class="error--text my-5">
              1 - Um ou mais produtos estão com preço/quantidade inválida para exportação.
            </h3>
            <h3 class="error--text my-5">
              2 - Preço e Quantidade devem ser superior a 0.
            </h3>
          </div>
          <div v-else class="mt-5">
            <h3 class="text-center mb-5" style="color: green">{{ sucesso }}</h3>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="erros.length > 0" text @click="voltar()">Voltar</v-btn>
          <v-btn v-else text @click="fechar()">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import CarrinhoAPI from "./../../../api/carrinho";
import ProtheusAPI from "./../../../api/protheus";
import DrpAPI from "./../../../api/drp";
import {required} from "vuelidate/lib/validators";

export default {
  model:  {
    prop: "valor_modelo",
    event: "atualizacao:valor_modelo"
  },
  props: ["valor_modelo", "pedidoSelecionado", 'produtoInvalidoParaExportacao'],
  data: () => ({
    dialogStatus: false,
    codProtheus: null,
    dataEntrega: "",
    data_limite_faturamento: '',
    atualizarComponente: true,
    sucesso: "",
    erros: [],
    selects: {
      fornecedores: {
        items: [],
        value: "",
      },
      filiais: {
        items: [],
        value: "",
      },
      condPagamento: {
        items: [],
        value: "",
      },
    },
    loading: {
      filial: false,
      fornecedor: false,
      condPagamento: false,
    }
  }),
  validations: {
    dataEntrega: {
      required,
      min() {
        if (this.dataEntrega == "") return false;

        let data = new Date(this.dataEntrega);
        let hoje = new Date();

        return data > hoje;
      },
    },
    data_limite_faturamento: {
      required,
      min() {
        if (this.data_limite_faturamento == "") return false;

        let data = new Date(this.data_limite_faturamento);
        let hoje = new Date();

        return data > hoje;
      },
    },
    selects: {
      fornecedores: {
        value: {
          required,
        },
      },
      filiais: {
        value: {
          required,
        },
      },
      condPagamento: {
        value: {
          required,
        },
      },
    },
  },
  computed: {
    dialog_ativo: {
      get: function () {
        return this.valor_modelo;
      },
      set: function (novo_valor) {
        return this.$emit("atualizacao:valor_modelo", novo_valor);
      }
    },
    dataEntregaErrors() {
      const errors = [];

      if (!this.$v.dataEntrega.$dirty) return errors;
      !this.$v.dataEntrega.required && errors.push("Campo Obrigatório.");
      !this.$v.dataEntrega.min &&
      errors.push("Data entrega deve ser posterior a hoje.");
      return errors;
    },
    dataLimiteFaturamentoErrors() {
      const errors = [];

      if (!this.$v.data_limite_faturamento.$dirty) return errors;
      !this.$v.data_limite_faturamento.required && errors.push("Campo Obrigatório.");
      !this.$v.data_limite_faturamento.min && errors.push("Data entrega deve ser posterior a hoje.");
      return errors;
    },
    fornecedorErrors() {
      const errors = [];
      if (!this.$v.selects.fornecedores.value.$dirty) return errors;
      !this.$v.selects.fornecedores.value.required &&
      errors.push("Campo Obrigatório.");
      return errors;
    },
    filialErrors() {
      const errors = [];
      if (!this.$v.selects.filiais.value.$dirty) return errors;
      !this.$v.selects.filiais.value.required &&
      errors.push("Campo Obrigatório.");
      return errors;
    },
    condPagamentoErrors() {
      const errors = [];
      if (!this.$v.selects.condPagamento.value.$dirty) return errors;
      !this.$v.selects.condPagamento.value.required &&
      errors.push("Campo Obrigatório.");
      return errors;
    },
    qtdeDias() {
      if (this.dataEntrega === "") return "";

      const data = new Date(this.dataEntrega);
      const hoje = new Date();

      const diffTime = Math.abs(data - hoje);
      return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    },
    qtdeDiasDataLimiteFaturamento() {
      if (this.data_limite_faturamento === "") return "";

      const data = new Date(this.data_limite_faturamento);
      const hoje = new Date();

      const diffTime = Math.abs(data - hoje);
      return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    },
    disabledTextField() {
      if (!this.codProtheus) return true;
      return this.pedidoSelecionado.pedido_cli !== "0";
    },
  },
  watch: {
    dialog_ativo() {
      if (this.dialog_ativo) {
        this.defaultComponente();

        if (this.atualizarComponente && !this.produtoInvalidoParaExportacao) {
          this.atualizarComponente = false;

          if (!this.pedidoSelecionado.pedido_cli == "0") {
            const {
              data_entrega,
              cond_pagamento
            } = this.pedidoSelecionado;

            this.dataEntrega = data_entrega;

            this.selects.condPagamento.value = cond_pagamento;
          }
        }

        if (this.produtoInvalidoParaExportacao) {
          this.$emit("fechar")
          this.dialogStatus = true
        }
      }
    },
    'pedidoSelecionado.idfornecedor': function() {
      this.atualizarComponente = true;
    },
    pedidoSelecionado() {
      this.buscarFiliais();
    }
  },
  methods: {
    defaultComponente() {
      this.buscarFornecedores();
      this.buscarFiliais();
      this.buscarCondPagamentoEDataEntrega();
    },
    exportarProtheus() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        const headers = this.Helpers.iniciarRequisicao();

        const { idpedido, pedido_cli } = this.pedidoSelecionado;

        const params = {
          idpedido,
          pedido_cli,
          cnpj: this.selects.fornecedores.value,
          condicao: this.selects.condPagamento.value,
          filial: this.selects.filiais.value,
          dataEntrega: this.dataEntrega,
          data_limite_faturamento: this.data_limite_faturamento,
          codProtheus: this.codProtheus,
        };

        this.$store.dispatch(
          "loading/addRequisicao",
          ProtheusAPI.incluirPedidoCompraProtheus(headers, params)
            .then((response) => {
              const { token, erros } = response.data;
              localStorage.setItem("token", token);

              if (!erros.length > 0) {
                this.erros = [];

                if (this.pedidoSelecionado.pedido_cli !== "0") {
                  this.sucesso = "Pedido editado com sucesso no protheus.";
                } else {
                  this.sucesso = "Pedido exportado com sucesso para o protheus.";
                }

                this.$emit("exportacao-com-sucesso")
              } else {
                this.sucesso = "";
                this.erros = erros;
              }

              this.dialogStatus = true;
              this.$emit("fechar");
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      }
    },
    selectFilialDefault() {
      const lengthF = this.selects.filiais.items.length;

      for (let i = 0; i < lengthF; i++) {
        const filial = this.selects.filiais.items[i];

        if (["S", "s"].includes(filial.matriz)) {
          this.selects.filiais.value = filial.id;
          i = lengthF;
        }
      }
    },
    buscarFiliais() {
      this.loading.filial = true;
      const headers = this.Helpers.iniciarRequisicao();

      const params = { grupo: this.pedidoSelecionado.grupo };

      DrpAPI.getFiliaisDrp(headers, params)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          if (response.status === 200) {
            this.selects.filiais.items = response.data.filiais;
            this.selectFilialDefault();
          }

          this.loading.filial = false;
        })
        .catch(() => {
          this.Helpers.logout();
        });
    },
    buscarFornecedores: function () {
      this.loading.fornecedor = true;
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        idpedido: this.pedidoSelecionado.idpedido,
        fabricante: this.pedidoSelecionado.idfornecedor,
      };

      CarrinhoAPI.getFornecedorFabricante(headers, params)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          if (response.status == 200) {
            const fornecedores = response.data.forneFabri;

            fornecedores.forEach((forn) => {
              if (forn.idfornecedor === this.pedidoSelecionado.idfornecedor_pedido) {
                this.selects.fornecedores.value = forn.cnpj
              }

              this.selects.fornecedores.items.push({
                cnpj: forn.cnpj,
                idfornecedor: forn.idfornecedor,
                razao_social: "".concat(
                  'Loja: ',
                  forn.loja,
                  " / CNPJ: ",
                  forn.cnpj,
                  " / FORNECEDOR: ",
                  forn.razao_social
                ),
              });
            });

            this.loading.fornecedor = false;
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });
    },
    buscarCondPagamentoEDataEntrega() {
      this.loading.condPagamento = true;
      const headers = this.Helpers.iniciarRequisicao();

      const { idpedido } = this.pedidoSelecionado;

      const params = { idpedido };

      ProtheusAPI.getCondPagamentoEDataEntrega(headers, params)
        .then((response) => {
          const { token, condPagamento, dataEntrega, codSistema, data_limite_faturamento } = response.data;
          localStorage.setItem("token", token);

          if (response.status == 200) {
            this.selects.condPagamento.items = condPagamento;
            this.dataEntrega = dataEntrega;
            this.data_limite_faturamento = data_limite_faturamento;

            if (codSistema) {
              this.codProtheus = codSistema;
            } else {
              this.setUsuarioSemPermissao()
            }

            this.loading.condPagamento = false;
          }
        })
        .catch(() => {
          this.loading.condPagamento = false;
          this.Helpers.logout();
        });
    },
    setUsuarioSemPermissao () {
      this.fechar();
      this.erros = [{ Message: "Usuário sem permissão!" }];
      this.dialogStatus = true;
    },
    voltar() {
      this.dialogStatus = false;
      this.dialog_ativo = true;
    },
    fechar() {
      if (this.pedidoSelecionado.pedido_cli == "0") {
        this.selects.fornecedores.value = "";
        this.selects.condPagamento.value = "";
      }
      this.$emit("fechar");
      this.dialogStatus = false;
      this.dialog_ativo = false;
      this.$v.$reset();
      this.sucesso = "";
      this.erros = [];
    },
  },
};
</script>
